/**
 * Legal pages: fills the empty .legal-toc box with a numbered list of the page's .legal-clause
 * sections and marks the one being read. Each clause gets an id from its heading, so the links are
 * plain #anchors (motion.js glides to them with Lenis and stops clear of the sticky header).
 */
( function () {
	'use strict';

	var toc = document.querySelector( '.legal-toc' );
	var layout = toc && toc.closest( '.legal-layout' );
	if ( ! layout ) {
		return;
	}

	var clauses = Array.prototype.slice.call( layout.querySelectorAll( '.legal-clause' ) );
	if ( ! clauses.length ) {
		return;
	}

	var links = {};
	var used = {};
	// inc/legal.php prints the list in the HTML; build it here only if it is missing.
	var list = toc.querySelector( '.legal-toc__list' );
	var built = !! list;
	if ( built ) {
		Array.prototype.forEach.call( list.querySelectorAll( 'a[href^="#"]' ), function ( link ) {
			links[ decodeURIComponent( link.hash.slice( 1 ) ) ] = link;
		} );
		clauses = clauses.filter( function ( clause ) {
			return clause.id && links[ clause.id ];
		} );
		if ( ! clauses.length ) {
			return;
		}
	} else {
		list = document.createElement( 'ol' );
		list.className = 'legal-toc__list';
	}

	( built ? [] : clauses ).forEach( function ( clause ) {
		var heading = clause.querySelector( 'h2, h3' );
		if ( ! heading ) {
			return;
		}
		var label = heading.textContent.replace( /^\s*\d+\.\s*/, '' ).trim();
		var id = clause.id;
		if ( ! id ) {
			id = label.toLowerCase().replace( /[^a-z0-9]+/g, '-' ).replace( /^-|-$/g, '' ) || 'section';
			while ( used[ id ] || document.getElementById( id ) ) {
				id += '-2';
			}
			clause.id = id;
		}
		used[ id ] = true;

		var item = document.createElement( 'li' );
		var link = document.createElement( 'a' );
		link.href = '#' + id;
		link.textContent = label;
		item.appendChild( link );
		list.appendChild( item );
		links[ id ] = link;
	} );

	if ( ! built ) {
		toc.appendChild( list );
	}

	var current = null;
	function setActive( id ) {
		if ( id === current || ! links[ id ] ) {
			return;
		}
		if ( current && links[ current ] ) {
			links[ current ].classList.remove( 'is-active' );
			links[ current ].removeAttribute( 'aria-current' );
		}
		links[ id ].classList.add( 'is-active' );
		links[ id ].setAttribute( 'aria-current', 'true' );
		current = id;
	}

	list.addEventListener( 'click', function ( event ) {
		var link = event.target.closest( 'a' );
		if ( link ) {
			setActive( link.hash.slice( 1 ) );
		}
	} );

	// The active section is the last one whose top has passed a line 30% down the window.
	var ticking = false;
	function update() {
		ticking = false;
		var line = window.innerHeight * 0.3;
		var active = clauses[ 0 ].id;
		for ( var i = 0; i < clauses.length; i++ ) {
			if ( clauses[ i ].getBoundingClientRect().top - line <= 0 ) {
				active = clauses[ i ].id;
			}
		}
		// At the end of the page the last short sections cannot reach the line: mark the last one.
		var last = clauses[ clauses.length - 1 ].getBoundingClientRect();
		if ( last.bottom <= window.innerHeight && last.top < window.innerHeight * 0.6 ) {
			active = clauses[ clauses.length - 1 ].id;
		}
		setActive( active );
	}
	function onScroll() {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	}

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll );

	if ( location.hash && links[ decodeURIComponent( location.hash.slice( 1 ) ) ] ) {
		setActive( decodeURIComponent( location.hash.slice( 1 ) ) );
	} else {
		update();
	}
}() );
